module.exports = __webpack_public_path__ + "img/chapter-1-thumb.65bf25d4.jpg";